export default [
  {
    url: "/back",
    name: "분야 바로가기",
    icon: "ArrowLeftIcon",
    activeCode: "",
  },
  {
    url: "/home",
    name: "대시보드",
    icon: "",
    activeCode: "",
  },
  {
    url: "/",
    name: "사업장/시설물 현황",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/field/facility",
        name: "시설물 현황",
        icon: "w-line",
        activeCode: "field-facility",
      },
      {
        url: "/field/workplace-material",
        name: "원료·제조물 사업장 현황",
        icon: "w-line",
        activeCode: "field-workplace-material",
        groupName: ["593"],
      },
    ],
  },
  {
    url: "/",
    name: "의무이행사항 점검(반기1회)",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/537",
        name: "공중이용시설",
        icon: "w-line",
        activeCode: "",
        groupName: ["537", "538"],
      },
      {
        url: "/tab/535",
        name: "원료·제조물 사업장",
        icon: "w-line",
        activeCode: "",
        groupName: ["535","536"],
      },
    ],
  },
  {
    url: "/tab/461",
    name: "인력 현황",
    icon: "",
    activeCode: "",
    groupName: ["461"],
  },
  {
    url: "/",
    name: "안전보건 예산",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/610",
        name: "공중이용시설 안전예산",
        icon: "w-line",
        activeCode: "",
        groupName: ["610"],
      },
      {
        url: "/tab/611",
        name: "원료·제조물 사업장 안전예산",
        icon: "w-line",
        activeCode: "",
        groupName: ["611"],
      },
      {
        url: "/tab/155",
        name: "공중이용시설 안전예산(년월별)",
        icon: "w-line",
        activeCode: "",
        groupName: ["155"],
      },
      {
        url: "/tab/409",
        name: "원료·제조물 사업장 안전예산(년월별)",
        icon: "w-line",
        activeCode: "",
        groupName: ["409"],
      },
    ],
  },
  {
    url: "/",
    name: "안전점검",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/598",
        name: "정기·정밀안전점검",
        icon: "w-line",
        activeCode: "",
        groupName: ["598"],
      },
      {
        url: "/tab/599",
        name: "기타 안전점검",
        icon: "w-line",
        activeCode: "",
        groupName: ["599"],
      },
      {
        url: "/tab/600",
        name: "시설 보수·보강",
        icon: "w-line",
        activeCode: "",
        groupName: ["600"],
      },
    ],
  },
  {
    url: "/",
    name: "안전계획",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/317",
        name: "중대시민재해 종합계획",
        icon: "w-line",
        activeCode: "",
        groupName: ["317"],
      },
      {
        url: "/tab/337",
        name: "관리부서",
        icon: "w-line",
        activeCode: "",
        groupName: ["337"],
      },
      {
        url: "/tab/311",
        name: "수탁업체",
        icon: "w-line",
        groupName: ["311"],
      },
    ],
  },
  {
    url: "/",
    name: "업무처리절차",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/601",
        name: "업무처리절차(현장조치 행동매뉴얼)",
        icon: "w-line",
        activeCode: "",
        groupName: ["601"],
      },
      {
        url: "/tab/352",
        name: "유해·위험점검(시설물) 이행",
        icon: "w-line",
        activeCode: "",
        groupName: ["352", "353", "354", "602"],
      },
      {
        url: "/tab/355",
        name: "유해·위험점검(사업장) 이행",
        icon: "w-line",
        activeCode: "",
        groupName: ["355"],
      },
      {
        url: "/tab/603",
        name: "비상대피훈련",
        icon: "w-line",
        activeCode: "",
        groupName: ["603"],
      },
    ],
  },
  {
    url: "/",
    name: "도급·용역·위탁",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/604",
        name: "수급업체 평가 기준·절차",
        icon: "w-line",
        activeCode: "",
        groupName: ["604"],
      },
      {
        url: "/tab/376",
        name: "수급업체 평가(연1회)",
        icon: "w-line",
        activeCode: "",
        groupName: ["376"],
      },
    ],
  },
  {
    url: "/tab/356",
    name: "법정의무교육 이수",
    icon: "",
    activeCode: "",
    groupName: ["356"],
  },
  {
    url: "/tab/605",
    name: "중대시민재해 재발방지대책",
    icon: "",
    activeCode: "",
    groupName: ["605"],
  },
  {
    url: "/community",
    name: "커뮤니티",
    slug: "community",
    icon: "",
    submenu: [
      {
        url: "/community/businessnews",
        name: "중대재해 발생 사례 공유",
        activeCode: "community_businessnews",
        icon: "w-line",
        groupName: ['16'],
      },
      {
        url: "/community/healthinfo",
        name: "안전보건 주요 일정",
        activeCode: "community_healthinfo",
        icon: "w-line",
        groupName: ['18'],
      },
      {
        url: "/community/unitbusinessnews",
        name: "구성원 요청사항",
        activeCode: "community_unitbusinessnews",
        icon: "w-line",
        groupName: ['19'],
      },
      {
        url: "/community/qna",
        name: "Q&A",
        activeCode: "community_qna",
        icon: "w-line",
        groupName: ['17'],
      },
    ],
  },
  {
    url: "/mypage",
    name: "마이페이지",
    slug: "safety",
    icon: "",
    submenu: [
      {
        url: "/mypage/workstatus",
        name: "업무현황",
        slug: "",
        icon: "w-line",
        groupName: ['90'],
      },
      {
        url: "/mypage/alert",
        name: "알림",
        slug: "",
        icon: "w-line",
        groupName: ['91'],
      },
      {
        url: "/",
        name: "설정",
        slug: "",
        icon: "w-line",
        submenu: [
          {
            url: "/mypage/info-update",
            name: "개인정보변경",
            slug: "",
            icon: "w-line",
            groupName: ['92'],
          },
        ],
      },
    ],
  },
];
